import React, {
    FocusEventHandler,
    MouseEventHandler,
    KeyboardEventHandler,
} from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import {
    ChildReferenceProps,
    ChildReferenceComponent,
} from 'src/utils/accessibility/ChildReferenceComponent';
import { propStyles } from 'src/utils/propStyles';
import { styled } from 'src/utils/styled';

const FilterDropdownButton = styled<any, any>(
    'button',
    'filterDropdownButton',
    'filterItemDropdown'
)`
    ${propStyles};
    outline: none;
    cursor: pointer;
`;

FilterDropdownButton.defaultProps = {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 'sm',
    fontSize: 'sm',
    fontFamily: 'body',
    fontWeight: 'normal',
    color: 'gray500',
    bgColor: 'white',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    hover: {
        borderColor: 'primary',
    },
    selected: {
        color: 'body',
        borderColor: 'primary',
    },
};

interface Props<HTMLButtonElement>
    extends ChildReferenceProps<HTMLButtonElement> {
    isFocused: boolean;
    onBlur: (event: FocusEventHandler<HTMLButtonElement>) => void;
    onClick: (event: MouseEventHandler<HTMLButtonElement>) => void;
    onKeyDown: (event: KeyboardEventHandler<HTMLButtonElement>) => void;
    onKeyUp: (event: KeyboardEventHandler<HTMLButtonElement>) => void;
    ariaLabel: string;
    dataSelected: boolean;
    dataMetricId: string;
}

@inject('dataStore')
@observer
class FilterItemDropdownButton extends ChildReferenceComponent<
    Props<HTMLButtonElement>,
    HTMLButtonElement
> {
    get shouldApplyFocus() {
        return this.props.isFocused;
    }

    get renderProps() {
        const { ariaLabel, dataMetricId, dataSelected } = this.props;

        return {
            'aria-label': ariaLabel,
            'data-selected': dataSelected,
            'data-metric-id': dataMetricId,
            ...this.interactiveProps,
        };
    }

    render() {
        const { children, ...props } = this.props;

        return (
            <FilterDropdownButton {...this.renderProps} {...props}>
                {children}
            </FilterDropdownButton>
        );
    }
}

export default withTheme(FilterItemDropdownButton);



// WEBPACK FOOTER //
// ./src/Components/Filters/Components/Filter/FilterItemDropdownButton.tsx